define(["require", "exports", "jquery", "./BuildingLinks", "jquery-ui/ui/widget"], function (require, exports, $, BuildingLinks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $.widget('buildings.buildingLinks', new BuildingLinks_1.default());
});
